import React from "react";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import Insta from "../Images/Insta.png";
import Twitter from "../Images/Twitter.png";
import Github from "../Images/Git.png";
import Linkedin from "../Images/Linkedin.png";

function Contact() {
  function Submit(e) {
    const formEle = document.querySelector("form");
    const formDatab = new FormData(formEle);
    fetch(
      "https://script.google.com/macros/s/AKfycbxtsCR7_dlQae8TDl-0er7PIb4wAluSejiUMF8r-3d58d6A7PZU-RXb-jWrfnnt-l4/exec",
      {
        method: "POST",
        body: formDatab
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div className="mt-28 md:mt-24">
      <Header />
      <div className="p-1 md:p-14 lg:p-24">
        <h1 className="text-2xl md:text-4xl font-medium mt-5 md:mt-0 text-black/80 dark:text-white/90 text-center transition-all ease-linear duration-200">
          GET IN TOUCH
        </h1>
        <h3 className="text-xl md:text-2xl text-slate-700 dark:text-slate-300 text-justify p-7 md:p-8 lg:w-5/6 mx-auto transition-all ease-linear duration-200">
          If you want to get in touch with me, you can reach out to me through 
          my social media links or drop me message below. I would love to connect with like-minded 
          individuals and discuss technology and other interests.
        </h3>
        {/* <div className="flex gap-10 justify-center m-2">
          <a href="https://www.instagram.com/sahil_d_07">
            <img
              src={Insta}
              alt=""
              className="icon w-12 h-12 "
            />
          </a>
          <a href="https://twitter.com/Sahil_2904">
            <img
              src={Twitter}
              alt=""
              className="icon w-12 h-12 "
            />
          </a>
          <a href="https://github.com/Sahil-2904">
            <img
              src={Github}
              alt=""
              className="icon w-12 h-12 "
            />
          </a>
          <a href="https://www.linkedin.com/in/sahil-dhoot-6a7282225/">
            <img
              src={Linkedin}
              alt=""
              className="icon w-12 h-12 "
            />
          </a>
        </div> */}
      {/* </div>
      <div> */}
        {/* <h3 className="text-center pb-0 pt-2  text-2xl md:text-3xl dark:text-slate-50">
          CONTACT
        </h3> */}
        <form
          onClick={(e) => {Submit(e)}}
          className="flex flex-col justify-center gap-10"
        >
          <div className="flex flex-col flex-wrap gap-4 justify-center p-3 md:p-0 md:w-5/6 md:mx-auto lg:p-5">
            <input className="text-xl p-4 bg-[#fff] dark:bg-[#141619] w-11/12 md:w-full mx-auto  shadow-lg  rounded-xl dark:text-white text-[#141619]  outline-sky-500 transition-all ease-linear duration-200" id="1" type="text" placeholder="Name" name="Name" required/>
            <input className="text-xl p-4 bg-[#fff] dark:bg-[#141619] w-11/12 md:w-full mx-auto shadow-lg  rounded-xl dark:text-white text-[#141619] outline-sky-500 transition-all ease-linear duration-200" id="2" type="text" placeholder="Email" name="Email" required/>
            <textarea className="text-xl p-4 bg-[#fff] dark:bg-[#141619] w-11/12 md:w-full mx-auto shadow-lg  rounded-xl dark:text-white text-[#141619] outline-sky-500 transition-all ease-linear duration-200" id="3" type="text" placeholder="Message" name="Message" rows="3" cols="40" required/>
          </div>
          <div className="justify-center flex">
            <button
              type="submit"
              className="text-xl text-center text-lime-50 dark:text-slate-900 bg-sky-400 dark:bg-sky-500 hover:bg-gradient-to-br from-sky-500 to-sky-600 dark:hover:text-slate-100 w-24 h-14 rounded-3xl shadow-md"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
